import { formatEnumKeyLabel } from '../../util/genericHelpers.js';

export const hasValue = value => {
  if (typeof value === 'string') {
    return value.trim().length > 0;
  }

  return value !== null && value !== undefined;
};

export const formatDisplayValue = value => {
  if (!hasValue(value)) {
    return null;
  }

  return typeof value === 'string' ? value.trim().replace(/[-_]+/g, ' ') : String(value);
};

export const formatRawDisplayValue = value => {
  if (!hasValue(value)) {
    return null;
  }

  return typeof value === 'string' ? value.trim() : String(value);
};

export const normalizeComparableValue = value => {
  if (typeof value !== 'string') {
    return '';
  }

  return value.trim().toLowerCase();
};

export const getInventoryDisplayValue = stockType => {
  if (stockType === 'unlimited') {
    return 'Made to order';
  }

  if (stockType === 'finite') {
    return 'Limited quantity';
  }

  return null;
};

export const getShippingDetails = shippingDimensions => {
  if (!shippingDimensions || typeof shippingDimensions !== 'object') {
    return null;
  }

  const { length, width, height, distanceUnit, weight, unit } = shippingDimensions;
  const sizeUnit = formatDisplayValue(distanceUnit);
  const weightUnit = formatDisplayValue(unit);
  const details = [];

  if (hasValue(length)) {
    details.push(`L: ${length}${sizeUnit ? ` ${sizeUnit}` : ''}`);
  }
  if (hasValue(width)) {
    details.push(`W: ${width}${sizeUnit ? ` ${sizeUnit}` : ''}`);
  }
  if (hasValue(height)) {
    details.push(`H: ${height}${sizeUnit ? ` ${sizeUnit}` : ''}`);
  }
  if (hasValue(weight)) {
    details.push(`Weight: ${weight}${weightUnit ? ` ${weightUnit}` : ''}`);
  }

  return details.length > 0 ? details.join(', ') : null;
};

export const getBaseListingDetails = publicData => {
  if (!publicData || typeof publicData !== 'object') {
    return [];
  }

  const {
    categoryLevel1,
    categoryLevel2,
    brand,
    condition,
    stockType,
    shippingEnabled,
    shippingDimensions,
  } = publicData;
  const details = [];

  const maybeCategory = formatDisplayValue(categoryLevel1);
  if (maybeCategory) {
    details.push({ key: 'categoryLevel1', label: 'Category', value: maybeCategory });
  }

  const maybeSubcategory = formatDisplayValue(categoryLevel2);
  if (maybeSubcategory) {
    details.push({ key: 'categoryLevel2', label: 'Subcategory', value: maybeSubcategory });
  }

  const maybeBrand = formatRawDisplayValue(brand);
  if (maybeBrand) {
    details.push({ key: 'brand', label: 'Brand', value: maybeBrand });
  }

  const maybeCondition = formatEnumKeyLabel(condition);
  if (maybeCondition) {
    details.push({ key: 'condition', label: 'Condition', value: maybeCondition });
  }

  const inventoryDisplayValue = getInventoryDisplayValue(stockType);
  if (inventoryDisplayValue) {
    details.push({ key: 'stockType', label: 'Inventory', value: inventoryDisplayValue });
  }

  const shippingDetails = shippingEnabled ? getShippingDetails(shippingDimensions) : null;
  if (shippingDetails) {
    details.push({
      key: 'shippingDimensions',
      label: 'Shipping dimensions',
      value: shippingDetails,
    });
  }

  return details;
};
